<div>
  <h4>Licenciamento BCI</h4>
</div>
<form
  *ngIf="!spinnerVisibility"
  [formGroup]="profileForm"
  (ngSubmit)="onSubmit()"
>

  <div class="form-row">
    <div
      *ngIf="setor('FORM_ID')"
      class="form-group col-md-1"
    >
      <label for="id" class="col-form-label col-form-label-sm"
        ><span
          data-toggle="tooltip"
          data-placement="top"
          title="Identificador da Unidade Produtiva proveniente do SINDA"
          >ID</span
        ></label
      >
      <ng-template #upIdTootip
        >Identificador da Unidade Produtiva proveniente do SINDA</ng-template
      >
      <input
        type=" text"
        [ngbTooltip]="upIdTootip"
        class="form-control form-control-sm"
        id="id"
        name="id"
        formControlName="id"
      />
    </div>
    <div
      *ngIf="setor('FORM_UNIDADE_PRODUTIVA')"
      class="form-group col-md-2"
    >
      <label for="unidadeProdutiva" class="col-form-label col-form-label-sm"
        >Unidade Produtiva</label
      >
      <ng-template #upNomeTootip
        >Digite parte do nome ou nome completo da Unidade Produtiva</ng-template
      >
      <input
        type="text"
        [ngbTooltip]="upNomeTootip"
        class="form-control form-control-sm"
        id="unidadeProdutiva"
        name="unidadeProdutiva"
        formControlName="unidadeProdutiva"
      />
    </div>
    <div
      *ngIf="!temPerfil('ESTADUAL')"
      class="form-group col-md-1"
    >
      <label for="uf" class="col-form-label col-form-label-sm">UF</label>
      <select
        type="text"
        class="form-control form-control-sm"
        id="uf"
        name="uf"
        formControlName="uf"
      >
        <option selected value="">Selecione...</option>
        <option *ngFor="let uf of ufs" [value]="uf">{{ uf }}</option>
      </select>
    </div>
    <div
      *ngIf="setor('FORM_MUNICIPIO')"
      class="form-group col-md-2"
    >
      <label for="municipio" class="col-form-label col-form-label-sm"
        >Município</label
      >
      <ng-template #produtorMunicipioTooltip
        >Digite parte do nome ou nome completo do Município.</ng-template
      >
      <input
        type="text"
        class="form-control form-control-sm"
        id="municipio"
        name="municipio"
        formControlName="municipio"
        [ngbTooltip]="produtorMunicipioTooltip"
        [ngbTypeahead]="searchMunicipios"
      />
    </div>
    <div
      *ngIf="setor('FORM_TIPO')"
      class="form-group col-md-2"
    >
      <label for="tipo" class="col-form-label col-form-label-sm">Tipo</label>
      <select
        id="tipo"
        class="form-control form-control-sm"
        name="tipo"
        formControlName="tipo"
      >
        <option selected value="">Selecione...</option>
        <option>Grupo</option>
        <option>Produtor</option>
      </select>
    </div>
    <div
      *ngIf="setor('FORM_PRODUTOR_GRUPO')"
      class="form-group col-md-2"
    >
      <label for="produtorGrupo" class="col-form-label col-form-label-sm"
        >Produtor/Grupo</label
      >
      <ng-template #produtorGrupoTooltip
        >Digite parte do nome ou nome completo do Produtor ou Grupo de
        Produtores.</ng-template
      >
      <input
        type="text"
        class="form-control form-control-sm"
        id="produtorGrupo"
        name="produtorGrupo"
        formControlName="produtorGrupo"
        [ngbTooltip]="produtorGrupoTooltip"
        [ngbTypeahead]="search"
      />
    </div>
    <div
      *ngIf="setor('FORM_HABILITADO')"
      class="form-group col-md-2"
    >
      <label for="habilitada" class="col-form-label col-form-label-sm"
        >Habilitada</label
      >
      <ng-template #habilitadaTooltip
        >Unidades Produtivas liberadas para participar do Programa ABR na
        safra</ng-template
      >
      <select
        id="habilitada"
        [ngbTooltip]="habilitadaTooltip"
        class="form-control form-control-sm"
        name="habilitada"
        formControlName="habilitada"
      >
        <option selected value="">Selecione...</option>
        <option value="1">Sim</option>
        <option value="0">Não</option>
      </select>
    </div>
  </div>
  <div class="form-row">


    <div
      class="d-flex align-items-end form-group offset-9 button-content-responsive"
    >
      <button type="submit" class="btn btn-primary btn-sm">Pesquisar</button
      >&nbsp;
      <button class="btn btn-outline-secondary btn-sm" (click)="reset()">
        Limpar
      </button>
      &nbsp;
      <button
      *ngIf="
        temPerfil('ABR') ||
        temPerfil('RESPONSAVEL_ABR')
        "
      class="btn btn-warning btn-sm" (click)="exportarGridParaExcel()">Exportar Excel</button>

    </div>
  </div>
</form>

<div *ngIf="!spinnerVisibility" class="table">

  <div class="table-responsive table-striped">
    <table class="table" >
      <thead>
        <tr>
          <th>
             CÓDIGO DA FAZENDA
          </th>
          <th>
           NOME DA UNIDADE PRODUTIVA
          </th>
          <th >
          Nome do Grupo
          </th>
          <th>
            MUNICÍPIO
          </th>
          <th>
            PROPRIETÁRIO DA FAZENDA
          </th>
          <th>
            <span ngbTooltip="BCP (Better Cotton Platform) é a plataforma usada por um representante da fazenda para aprovar as transações de volumes (BCCU ou BCLEs) solicitadas pelos compradores.">PRIMEIRO NOME RESPONSÁVEL BCP</span> <span *ngIf="verificaEdicao()" style="color: red;" ngbTooltip="Preenchimento obrigatório">*</span>
          </th>
          <th>
            <span ngbTooltip="BCP (Better Cotton Platform) é a plataforma usada por um representante da fazenda para aprovar as transações de volumes (BCCU ou BCLEs) solicitadas pelos compradores.">SOBRENOME RESPONSÁVEL BCP</span> <span *ngIf="verificaEdicao()" style="color: red;" ngbTooltip="Preenchimento obrigatório">*</span>
          </th>
          <th>
           <span ngbTooltip="BCP (Better Cotton Platform) é a plataforma usada por um representante da fazenda para aprovar as transações de volumes (BCCU ou BCLEs) solicitadas pelos compradores.">E-MAIL RESPONSAVEL BCP</span> <span *ngIf="verificaEdicao()" style="color: red;" ngbTooltip="Preenchimento obrigatório">*</span>
          </th>
          <th>Área plantada (ha) <span *ngIf="verificaEdicao()" style="color: red;" ngbTooltip="Preenchimento obrigatório">*</span></th>
          <th>Área Licenciada (ha)</th>
          <th>Produtividade Pluma (kg/ha) <span *ngIf="verificaEdicao()" style="color: red;" ngbTooltip="Preenchimento obrigatório">*</span></th>
          <th>Produção Pluma (kg)</th>
          <th colspan="2" style="text-align: center;"><div *ngIf="verificaEdicao()"> <button class="btn btn-success btn-sm" style="width: 100%;" (click)="salvarTodasLinhas()">Salvar todos</button></div></th>

        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let col of dashboard">
          <td>
            <ng-container *ngIf="verificaEdicao()">
              <input
            style="width: 107px;"
            maxlength="20"
            type="text"
            class="form-control"
            [ngModel]="col.numeroCertificadoBCI"
            (ngModelChange)="col.numeroCertificadoBCI = $event"
            [disabled]="!podeEditarLinha(col)"
          />
      </ng-container>
      <ng-container *ngIf="!verificaEdicao()"> <div style="width: 107px;"> {{col.numeroCertificadoBCI}}</div> </ng-container>
          </td>
          <td>{{ col.nomeUnidadeProdutiva | uppercase }}</td>
          <td >
            <ng-container *ngIf="col.tipo === 'Grupo'">
            ({{ col.produtorGrupo }})
          </ng-container>
          <ng-container *ngIf="col.tipo !== 'Grupo'">
            -
          </ng-container>
          </td>
          <td>
            {{ col.municipio | uppercase }}
          </td>
          <td>
            <ng-container *ngIf="col.tipo === 'Produtor'">
            ({{ col.produtorGrupo }})
          </ng-container>
          <ng-container *ngIf="col.tipo !== 'Produtor'">
            -
          </ng-container>
          </td>
          <td>
            <ng-container *ngIf="verificaEdicao()">
              <input
                style="width: 150px;"
                maxlength="75"
                type="text"
                class="form-control"
                [ngModel]="col.firstNameResponsavelBCI"
                (ngModelChange)="col.firstNameResponsavelBCI = $event"
                [disabled]="!podeEditarLinha(col)"
              />
            </ng-container>
            <ng-container *ngIf="!verificaEdicao()">{{ col.firstNameResponsavelBCI }}</ng-container>
          </td>
          <td>
            <ng-container *ngIf="verificaEdicao()">
              <input
                style="width: 150px;"
                maxlength="75"
                type="text"
                class="form-control"
                [ngModel]="col.lastNameResponsavelBCI"
                (ngModelChange)="col.lastNameResponsavelBCI = $event"
                [disabled]="!podeEditarLinha(col)"
              />
            </ng-container>
            <ng-container *ngIf="!verificaEdicao()">{{ col.lastNameResponsavelBCI }}</ng-container>
          </td>
          <td>
            <ng-container *ngIf="verificaEdicao()">
              <input
                style="width: 190px;"
                maxlength="150"
                type="email"
                class="form-control"
                [ngModel]="col.emailResponsavelBCI"
                (ngModelChange)="col.emailResponsavelBCI = $event"
                [disabled]="!podeEditarLinha(col)"
              />
            </ng-container>
            <ng-container *ngIf="!verificaEdicao()">{{ col.emailResponsavelBCI }}</ng-container>
          </td>
        <td>
          <ng-container *ngIf="verificaEdicao()">
          <input
            style="width: 95px;"
            maxlength="11"
            type="text"
            class="form-control"
            [ngModel]="col.areaAlgodaoInput"
            (ngModelChange)="atualizarAreaAlgodao(col, $event)"
            (keypress)="allowDecimalNumbers($event)"
            (blur)="formatarAreaAlgodao(col)"
            [disabled]="!podeEditarLinha(col)"
          />
          </ng-container>
          <ng-container *ngIf="!verificaEdicao()">{{col.areaAlgodao | number | replaceNumber}}</ng-container>

      </td>

      <td>{{ getAreaConversao(col) | number | replaceNumber }}</td>

      <td>
        <ng-container *ngIf="verificaEdicao()">
        <input
        style="width: 65px;"
          type="text"
          class="form-control"
          maxlength="5"
          [ngModel]="col.produtividadePluma | number | replaceNumber"
          (ngModelChange)="col.produtividadePluma = parseNumber($event)"
          [ngClass]="{'border-red': col.produtividadePluma !== null && (col.produtividadePluma > 5000 || col.produtividadePluma < 250)}"
          (keypress)="allowOnlyNumbers($event)"
          [disabled]="!podeEditarLinha(col)"
        /></ng-container>
        <ng-container *ngIf="!verificaEdicao()">{{col.produtividadePluma | number | replaceNumber}}</ng-container>
      </td>
           <td >

            {{ calcularProducaoPluma(col) | number | replaceNumber}}
          </td>
          <td>
            <div *ngIf="verificaEdicao()">
            <button class="btn btn-outline-success btn-sm" [disabled]="!podeEditarLinha(col)" (click)="salvarLinhaIndividual(col)">
        Salvar
      </button>
            </div>
          </td>
          <td>

            <button class="btn btn-info btn-sm" (click)="abrirModalDetalhes(col)">Detalhes</button>

          </td>
        </tr>
      </tbody>
    </table>
    <app-modal-excel-bci
  *ngIf="mostrarModal"
  [titulo]="itemParaModal?.nomeUnidadeProdutiva | uppercase"
  [dados]="itemParaModal"
  (fechar)="fecharMeuModal()"
  ></app-modal-excel-bci>
  </div>

  <div class="d-flex flex-column flex-lg-row justify-content-between p-2">
    <p class="text-center">
      Exibindo {{ currentPageSize }} registros de {{ collectionSize }}
    </p>
    <ngb-pagination
      [collectionSize]="collectionSize"
      [(page)]="page"
      [maxSize]="5"
      [rotate]="true"
      [pageSize]="pageSize"
      (pageChange)="refreshPage()"
      class="d-flex d-lg-block justify-content-center"
    >
    </ngb-pagination>
    <div class="d-flex justify-content-center">
      <select
        class="custom-select"
        style="width: auto"
        [(ngModel)]="pageSize"
        (ngModelChange)="refreshPage()"
      >
        <option [ngValue]="10">10 itens por página</option>
        <option [ngValue]="25">25 itens por página</option>
        <option [ngValue]="50">50 itens por página</option>
        <option [ngValue]="100">100 itens por página</option>
        <option [ngValue]="200">200 itens por página</option>
      </select>
    </div>
  </div>
</div>
